module.exports = __webpack_public_path__ + "img/[发].fb403002.svg";